// Mirrors the backend `BookingContactRole` choices (booking/models.py).
// Single place to update when the role vocabulary changes.
export const CONTACT_ROLE_OPTIONS = [
  { value: "primary", label: "Primary" },
  { value: "family", label: "Family" },
  { value: "funeral_home", label: "Funeral Home" },
  { value: "other", label: "Other" },
] as const;

export type ContactRole = (typeof CONTACT_ROLE_OPTIONS)[number]["value"];

export const DEFAULT_CONTACT_ROLE: ContactRole = "family";
export const PRIMARY_CONTACT_ROLE: ContactRole = "primary";
